import { createContext, useContext, useEffect, useState, useCallback } from 'react';
import { accountMe, accountLogin, accountLogout } from '@/api/account';
import { logError } from '@/utils/logger';

const CustomerAuthContext = createContext(null);

export function CustomerAuthProvider({ children }) {
  const [customer, setCustomer] = useState(null);
  const [ready, setReady] = useState(false);

  const refresh = useCallback(async () => {
    try {
      setCustomer(await accountMe());
    } catch {
      setCustomer(null);
    } finally {
      setReady(true);
    }
  }, []);

  useEffect(() => {
    // CRITICAL: when returning from the Google OAuth callback, skip the /me check.
    // AuthCallback exchanges the session_id and establishes the session first.
    if (window.location.hash?.includes('session_id=')) {
      setReady(true);
      return;
    }
    refresh();
  }, [refresh]);

  const login = async (data) => { const u = await accountLogin(data); setCustomer(u); return u; };
  const logout = async () => { let res = null; try { res = await accountLogout(); } catch (err) { logError('Customer logout', err); } setCustomer(null); return res; };

  return (
    <CustomerAuthContext.Provider value={{ customer, ready, setCustomer, login, logout, refresh }}>
      {children}
    </CustomerAuthContext.Provider>
  );
}

export function useCustomerAuth() {
  const ctx = useContext(CustomerAuthContext);
  if (!ctx) throw new Error('useCustomerAuth must be used within CustomerAuthProvider');
  return ctx;
}
